import React from "react";

const ICONS = {
    import: <path d="M12 15.5V3.5M7.5 8L12 3.5 16.5 8M4.5 15v5h15v-5" />,
    chev: <path d="M9 5l7 7-7 7" />,
    search: <><circle cx="11" cy="11" r="6.5" /><path d="M20 20l-4.2-4.2" /></>,
    mic: <><rect x="9" y="2.5" width="6" height="11.5" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3.5" /></>,
    note: <><path d="M5 3.5h14v12l-5 5H5z" /><path d="M14 20.5v-5h5M8.5 8.5h7M8.5 12.5h4" /></>,
    star: <path d="M12 3.6l2.7 5.6 6 .8-4.4 4.2 1.1 6-5.4-3-5.4 3 1.1-6L3.3 10l6-.8z" />,
    edit: <path d="M4 20h4L19.5 8.5l-4-4L4 16z" />,
    file: <><path d="M6 3h8l4.5 4.5V21H6z" /><path d="M14 3v4.5h4.5" /></>,
    speaker: <><path d="M4 9.3h3.8L13 5v14l-5.2-4.3H4z" /><path d="M16.3 9.2a4 4 0 0 1 0 5.6M19 6.6a8 8 0 0 1 0 10.8" /></>,
    check: <path d="M5 12.5l4.8 4.8L19 7.5" />,
    share: <path d="M12 3v12.5M7.5 7.5L12 3l4.5 4.5M5 14v6h14v-6" />,
    down: <path d="M12 3.5v12M7.5 11L12 15.5 16.5 11M5 20h14" />,
    play: <path d="M8 5.2l11 6.8-11 6.8z" />,
    pause: <path d="M9.5 5v14M14.5 5v14" />,
};

export const AiIc = ({ name, size = "" }) => (
    <svg className={`nt-i ${size}`} viewBox="0 0 24 24">{ICONS[name]}</svg>
);
